import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Problem from "@/components/Problem";
import Positioning from "@/components/Positioning";
import Marquee from "@/components/Marquee";
import Topics from "@/components/Topics";
import Advantage from "@/components/Advantage";
import Audiences from "@/components/Audiences";
import Statement from "@/components/Statement";
import BookView from "@/components/BookView";
import Leseprobe from "@/components/Leseprobe";
import Author from "@/components/Author";
import OrderForm from "@/components/OrderForm";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-navy-950 font-body text-gray-100 overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <Problem />
        <Positioning />
        <Marquee />
        <Topics />
        <Advantage />
        <Audiences />
        <Statement />
        <BookView />
        <Leseprobe />
        <Author />
        <OrderForm />
      </main>
      <Footer />
    </div>
  );
}
